import React from 'react';
import './Project.css';
import { Link } from 'react-router-dom';
import CIR1 from './images/CIR1.png';
import White from './images/white.png';
function App() {
  return (
    <div className="flower-container">
      <div className="blur-background"></div> {/* Blur background element */}
      <div className="flower-header">
        {/* <div className="flower-logo">THEDEVOPSGUY</div> */}
      </div>
      <div className="flower-content">
        <div className="flower-section flower-resources">
          <div className="flower-section-header">Resources</div>
          <div className="flower-section-content">
            <Link to="/side" className='zero'>
              <h2>Free DevOps Resources: Zero to Hero</h2>
            </Link>
            <p>
              Master the DevOps lifecycle! This guide unlocks free resources to transform you from beginner to confident DevOps pro:
            </p>
            <ul>
              <li>Learn core concepts: DevOps fundamentals, Version Control (Git), Infrastructure as Code (IaC).</li>
              <li>Dive deeper: Configuration Management, Containerization & Orchestration.</li>
              <li>Free learning paths: YouTube channels, online courses, documentation & blogs.</li>
              <li>Connect with the community: Forums, open-source projects.</li>
            </ul>
            <p>Start your DevOps journey today!</p>
          </div>
        </div>
        <div className="flower-section flower-projects">
          <div className="flower-section-header">Projects</div>
          <div className="flower-section-content">
            <Link to="/s" className='zero'>
              <h2>DevOps Project Sections</h2>
            </Link>
            <ol>
              <li>Foundational Concepts: Learn the core building blocks of DevOps (philosophy, tools, Git, IaC, CI/CD).</li>
              <li>Advanced Practices: Master specific tools like Ansible, Docker, Kubernetes, and cloud integration.</li>
              <li>Real-World Projects: Apply your skills with hands-on projects, case studies, and troubleshooting guides.</li>
            </ol>
          </div>
        </div>
      </div>
      {/* <div className="circle inception"></div> */}
      <img src={CIR1} className="circle inception"></img>
      <div className="circle avatar"></div>
      <img src={White} className="circle titanic"></img>
      <div className="circle godfather"></div>
      <div className="circle matrix"></div>
      <div className="circle gladiator"></div>

    </div>
  );
}

export default App;


// import React from 'react';
// import './Project.css';
// import { Link } from 'react-router-dom';

// function App() {
//   return (
//     <div className="flower-container">
//       <div className="blur-background"></div> {/* Blur background element */}
//       <div className="flower-header">
//         {/* <div className="flower-logo">THEDEVOPSGUY</div> */}
//       </div>
//       <div className="flower-content">
//         <div className="flower-section flower-resources">
//           <div className="flower-section-header">Resources</div>
//           <div className="flower-section-content">
//             <Link to="/side">
//               <h2>Free DevOps Resources: Zero to Hero</h2>
//             </Link>
//             <p>
//               Master the DevOps lifecycle! This guide unlocks free resources to transform you from beginner to confident DevOps pro:
//             </p>
//             <ul>
//               <li>Learn core concepts: DevOps fundamentals, Version Control (Git), Infrastructure as Code (IaC).</li>
//               <li>Dive deeper: Configuration Management, Containerization & Orchestration.</li>
//               <li>Free learning paths: YouTube channels, online courses, documentation & blogs.</li>
//               <li>Connect with the community: Forums, open-source projects.</li>
//             </ul>
//             <p>Start your DevOps journey today!</p>
//           </div>
//         </div>
//         <div className="flower-section flower-projects">
//           <div className="flower-section-header">Projects</div>
//           <div className="flower-section-content">
//             <Link to="/s">
//               <h2>DevOps Project Sections</h2>
//             </Link>
//             <ol>
//               <li>Foundational Concepts: Learn the core building blocks of DevOps (philosophy, tools, Git, IaC, CI/CD).</li>
//               <li>Advanced Practices: Master specific tools like Ansible, Docker, Kubernetes, and cloud integration.</li>
//               <li>Real-World Projects: Apply your skills with hands-on projects, case studies, and troubleshooting guides.</li>
//             </ol>
//           </div>
//         </div>
//       </div>
//       <div className="circle inception"></div>
//       <div className="circle avatar"></div>
//       <div className="circle titanic"></div>
//       <div className="circle godfather"></div>
//       <div className="circle matrix"></div>
//       <div className="circle gladiator"></div>
//     </div>
//   );
// }

// export default App;
